import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  subOrgs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  parentOrgDetail: { data: null, loading: false },
  unAuthedBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  authedBrands: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  dialog: { type: '', visible: false, loading: false },
  confirm: { type: '', title: '', content: '', data: null, visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
